import React, {useCallback, useEffect, useRef, useState} from 'react';
import './chat-test.css'; // Asegúrate que este archivo exista y esté actualizado
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMicrophone, faMicrophoneSlash, faPhone, faPhoneSlash, faWaveSquare} from '@fortawesome/free-solid-svg-icons'; // Asegúrate de tener estos iconos instalados
import AudioPulse from "./audio-pulse/audio-pulse.jsx";
import ConversationTimer from "./conversation-timer/conversation-timer.jsx";
import FeedbackList from "./feedback-list/feedback-list.jsx";
import {useParams} from "react-router-dom";
import {
    deleteSurveyThunk,
    getAllSurveysWithScheduleThunk, getAllUserSurveysThunk,
    getSingleSurveysWithQandAThunk
} from "../../redux/survey/survey.thunk";
import {connect} from "react-redux";
// import {resampleAudioBuffer} from "../../helpers/audio.js";

// --- Configuración ---
// const BACKEND_WS_URL = 'wss://72e1-181-115-172-62.ngrok-free.app/ws-ccs/interview'; // Ajusta si tu backend corre en otro puerto
// const BACKEND_WS_URL = 'wss://b43a-2800-cd0-afc6-bd00-3495-9a1a-168d-24c8.ngrok-free.app/ws-bata-survey';
const BACKEND_WS_URL = "wss://live-api-backend-exd6dee4aphegkd7.eastus2-01.azurewebsites.net/ws-bata-survey"
const AUDIO_REQUESTED_SAMPLE_RATE = 16000; // Tasa de muestreo que pedimos y enviamos
const AUDIO_BUFFER_SIZE = 4096; // Tamaño del buffer para ScriptProcessorNode (potencia de 2)
const VIDEO_FRAME_INTERVAL_MS = 1000; // Intervalo para enviar frames de pantalla
const GEMINI_AUDIO_OUTPUT_SAMPLE_RATE = 24000; // Tasa de muestreo esperada del audio del backend

// --- Helper para convertir ArrayBuffer a Base64 ---
function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

// Helper para convertir Base64 a ArrayBuffer (para audio de backend)
function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}


function ChatTest(props) {
    const {job = "", closeLiveInterview = () => {}} = props;
    const {id: surveyId, userId} = useParams();
    const [isConnected, setIsConnected] = useState(false);
    const [isStreaming, setIsStreaming] = useState(false); // Controla si el audio stream está activo
    // const [isScreenSharing, setIs1ScreenSharing] = useState(false); // Controla si la pantalla se comparte
    const [error, setError] = useState(null); // Errores generales (WS, media)
    const [muted, setMuted] = useState(false); // Estado para silenciar el micrófono local
    const [isBotSpeaking, setIsBotSpeaking] = useState(false);
    const [botOutputVolume, setBotOutputVolume] = useState(0);
    const [feedbackEntries, setFeedbackEntries] = useState([]);
    const [hideLiveInteraction, setHideLiveInteraction] = useState(false);


    const ws = useRef(null);

    // --- Refs para Web Audio API (Captura de Audio) ---
    const audioContextRef = useRef(null); // Contexto para captura y reproducción
    const audioStreamSourceRef = useRef(null); // Fuente del stream del micrófono
    const scriptProcessorNodeRef = useRef(null); // Nodo para procesar audio
    const localAudioStreamRef = useRef(null); // Para guardar el stream original del micrófono
    // --- Fin Refs Web Audio API ---

    // --- Refs para Reproducción de Audio del Backend ---
    const audioQueueRef = useRef([]); // Cola de chunks de audio para reproducir
    const isPlayingAudioRef = useRef(false); // Estado de reproducción
    // --- Fin Refs Reproducción Audio ---

    // --- Refs para Compartir Pantalla ---
    // const videoStreamRef = useRef(null); // Stream de la pantalla
    // const videoElementForCaptureRef = useRef(null); // Elemento video oculto para capturar frames
    // const screenCaptureIntervalRef = useRef(null); // Intervalo para capturar frames
    // --- Fin Refs Compartir Pantalla ---

    const mutedRef = useRef(muted);
    const volumeIntervalRef = useRef(null);


    useEffect(() => {
        // start the conection, first time calling this component if jobDescription exist
        // TODO add better verification, maybe verify if the survey exist
        if (surveyId && userId) {
            (async () => {
                // setIsStreaming(true)
                // await startStreamingAndConnect();
            })()
        } else {
            setHideLiveInteraction(true)
        }
    }, [])

    useEffect(() => { mutedRef.current = muted; }, [muted]);

    useEffect(() => {
        if (isBotSpeaking) {
            volumeIntervalRef.current = setInterval(() => {
                setBotOutputVolume(0.2 + Math.random() * 0.8)
            }, 150)
        } else {
            if (volumeIntervalRef.current) {
                clearInterval(volumeIntervalRef.current);
                volumeIntervalRef.current = null;
            }
            setBotOutputVolume(0);
        }
        return () => {
            if (volumeIntervalRef.current) {
                clearInterval(volumeIntervalRef.current);
            }
        };
    }, [isBotSpeaking]);

    // --- Envío de Datos al WebSocket ---
    const sendData = useCallback((data) => {
        // Solo enviar si el WebSocket está abierto Y el streaming principal (audio) está activo
        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
            // console.debug("Enviando data:", data.type);
            ws.current.send(JSON.stringify(data));
        } else {
            console.warn('WebSocket no abierto o streaming inactivo al intentar enviar.', data.type);
            // Opcional: mostrar un error al usuario si intenta enviar algo cuando no debería
            // if (!isStreaming) setError("El streaming no está activo.");
        }
    }, [isStreaming]); // Dependencia: isStreaming

    // --- Reproducción de Audio del Backend ---
    const playQueuedAudio = useCallback(async () => {
        if (isPlayingAudioRef.current || audioQueueRef.current.length === 0) return;

        // Recrear o reanudar AudioContext si es necesario (para reproducción)
        if (!audioContextRef.current || audioContextRef.current.state === 'closed') {
            try {
                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)({sampleRate: GEMINI_AUDIO_OUTPUT_SAMPLE_RATE});
                if (audioContextRef.current.state === 'suspended') await audioContextRef.current.resume();
            } catch (e) {
                console.error("Error creando/reanudando AudioContext para reproducción:", e);
                setError("No se pudo inicializar audio para respuesta.");
                return;
            }
        }
        const audioContext = audioContextRef.current;

        isPlayingAudioRef.current = true;
        setIsBotSpeaking(true)

        while (audioQueueRef.current.length > 0) {
            const audioBufferChunk = audioQueueRef.current.shift();
            if (!audioBufferChunk || audioBufferChunk.byteLength === 0) continue;

            try {
                // Asumimos que el backend envía PCM de 16 bits
                const pcm16Data = new Int16Array(audioBufferChunk);
                // Convertir a Float32 para Web Audio API
                const float32Data = new Float32Array(pcm16Data.length);
                for (let i = 0; i < pcm16Data.length; i++) float32Data[i] = pcm16Data[i] / 32768.0; // Normalizar a -1.0 a 1.0

                if (audioContext.state === 'closed') {
                    console.warn("AudioContext (playback) cerrado, no se puede reproducir.");
                    isPlayingAudioRef.current = false;
                    setIsBotSpeaking(false)
                    audioQueueRef.current = [];
                    return;
                }

                // Crear un AudioBuffer y copiar los datos
                const audioBuffer = audioContext.createBuffer(1, float32Data.length, GEMINI_AUDIO_OUTPUT_SAMPLE_RATE);
                audioBuffer.copyToChannel(float32Data, 0);

                // Crear un BufferSource y reproducir
                const source = audioContext.createBufferSource();
                source.buffer = audioBuffer;
                source.connect(audioContext.destination); // Conectar al destino (altavoces)

                // Esperar a que el chunk termine de reproducirse
                await new Promise((resolve) => {
                    source.onended = resolve;
                    try {
                        source.start();
                    } catch (startError) {
                        console.error("Error al iniciar audio chunk:", startError);
                        resolve(); // Continuar con el siguiente chunk incluso si este falla
                    }
                });

            } catch (decodeError) {
                console.error('Error decodificando/reproduciendo audio chunk:', decodeError);
            }
        }
        isPlayingAudioRef.current = false;
        setIsBotSpeaking(false);
        // setTimeout(playQueuedAudio, 50); // Revisa la cola periódicamente (opcional, onmessage ya llama)
    }, []);


    // --- Detener Streams y WebSocket ---
    const stopStreamingAndDisconnect = useCallback(() => {
        if (!isStreaming) return; // Solo detener si está activo

        console.log("Deteniendo streaming y cerrando WebSocket...");

        // 1. Desconectar y detener nodos de Web Audio API (Audio Capture)
        if (scriptProcessorNodeRef.current) {
            scriptProcessorNodeRef.current.disconnect();
            scriptProcessorNodeRef.current.onaudioprocess = null; // Limpiar handler
            scriptProcessorNodeRef.current = null;
            console.log("ScriptProcessorNode desconectado.");
        }
        if (audioStreamSourceRef.current) {
            audioStreamSourceRef.current.disconnect();
            audioStreamSourceRef.current = null;
            console.log("MediaStreamSource desconectado.");
        }
        // Detener tracks de audio local explícitamente
        if (localAudioStreamRef.current) {
            localAudioStreamRef.current.getTracks().forEach(track => track.stop());
            localAudioStreamRef.current = null;
            console.log("Stream de audio local detenido.");
        }
        // Considera cerrar AudioContext si no se reutiliza pronto o al desmontar
        // if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
        //     audioContextRef.current.close().then(() => console.log("AudioContext cerrado."));
        //     audioContextRef.current = null; // Podría ser problemático si playQueuedAudio lo necesita
        // }


        // 2. Detener Compartir Pantalla
        // if (screenCaptureIntervalRef.current) {
        //     clearInterval(screenCaptureIntervalRef.current);
        //     screenCaptureIntervalRef.current = null;
        //     console.log("Intervalo video detenido.");
        // }
        // if (videoStreamRef.current) {
        //     videoStreamRef.current.getTracks().forEach(track => track.stop());
        //     videoStreamRef.current = null;
        //     console.log("Stream video/pantalla detenido.");
        // }
        // if (videoElementForCaptureRef.current) {
        //     videoElementForCaptureRef.current.srcObject = null;
        //     videoElementForCaptureRef.current.remove(); // Eliminar el elemento del DOM
        //     videoElementForCaptureRef.current = null;
        // }
        // setIsScreenSharing(false); // Asegurar estado de pantalla a false


        // 3. Limpiar cola de audio y estado de reproducción
        audioQueueRef.current = [];
        isPlayingAudioRef.current = false; // Asegurar que la reproducción se detiene

        // 4. Cerrar WebSocket
        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
            ws.current.close();
        }


        // 5. Actualizar estado principal
        setIsStreaming(false);
        setIsConnected(false);
        // setError(null); // Opcional: limpiar errores al detener

        console.log("Streaming detenido, recursos liberados y WebSocket cerrado.");
    }, [isStreaming]); // Dependencia: isStreaming


    // --- Iniciar Streams y Conectar WebSocket ---
    const startStreamingAndConnect = useCallback(async () => {
        const jobDescription = job.jobDescription || ""
        const studentInfo = job.student_curriculum || ""
        if (isStreaming) return; // Ya está activo

        console.log("0 Iniciando conexión WebSocket y streaming de audio (PCM)...");
        setError(null);
        // setMessages([]); // Opcional: limpiar mensajes al iniciar una nueva sesión

        // 1. Intentar conectar WebSocket si no está conectado
        if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
            console.log("1 WebSocket no conectado, intentando conectar...");
            // Configurar handlers ANTES de abrir
            ws.current = new WebSocket(BACKEND_WS_URL);

            ws.current.onopen = () => {
                console.log('2 WebSocket Conectado');
                setIsConnected(true);
                setError(null);
                // Una vez conectado, intentar iniciar los streams
                // Esto podría ser un callback o simplemente llamar a la lógica de streams aquí
                // Vamos a llamar a la lógica de streams directamente aquí para simplificar el flujo del botón


                if (ws.current && ws.current.readyState === WebSocket.OPEN) {
                    console.log("sending MSG ")
                    ws.current.send(JSON.stringify({
                        type: 'start_survey_session',
                        payload: {
                            survey_id: surveyId,
                            user_id: userId
                        }
                    }))
                }
                startMediaStreams(); // Llama a la función interna para iniciar media
            };

            ws.current.onclose = (event) => {
                console.log('3 WebSocket Desconectado:', event.reason, event.code);
                setIsConnected(false);
                // Si el WS se cierra inesperadamente mientras streameamos, detener todo
                if (isStreaming) { // Solo llamar a la función de limpieza si estábamos streameando
                    stopStreamingAndDisconnect(); // Esto también cierra el WS (redundante pero seguro)
                } else {
                    // Si no estábamos streameando, solo asegurar que el estado es false
                    setIsStreaming(false);
                    // setIsScreenSharing(false); // Asegurar estado de pantalla también
                    setIsBotSpeaking(false)
                }
                if (!event.wasClean) setError(`Conexión perdida: ${event.reason || 'Error desconocido'} (Código: ${event.code})`);
                else setError(null); // Limpiar error si el cierre fue limpio
            };

            ws.current.onerror = (err) => {
                console.error('WebSocket Error:', err);
                setError('Error en la conexión WebSocket.');
                setIsConnected(false);
                // Si hay un error en el WS mientras streameamos, detener todo
                if (isStreaming) { // Solo llamar a la función de limpieza si estábamos streameando
                    stopStreamingAndDisconnect(); // Esto también cierra el WS (redundante pero seguro)
                } else {
                    // Si no estábamos streameando, solo asegurar que el estado es false
                    setIsConnected(false);
                    setIsStreaming(false);
                    // setIsScreenSharing(false);
                    setIsBotSpeaking(false);
                }
            };

            ws.current.onmessage = (event) => {
                try {
                    const message = JSON.parse(event.data);
                    console.warn('Mensaje recibido:', message.type);
                    if (message.type === 'text') {
                        // Podrías añadir mensajes de texto del asistente si los envía
                        // setMessages((prev) => [...prev, { sender: 'gemini', text: message.data }]);
                        console.log("Mensaje de texto del backend:", message.data);

                        const feedbackData = message.data;
                        if (feedbackData
                            && typeof feedbackData.question === 'string'
                            && typeof feedbackData.response === 'string'
                            && typeof feedbackData.feedback === 'string') {
                            setFeedbackEntries((prev) => [...prev, {...feedbackData, id: Date.now() + Math.random()}]);
                        } else {
                            console.warn("recived text msg with unnespected structure")
                        }
                    } else if (message.type === 'audio') {
                        const audioBytes = base64ToArrayBuffer(message.data); // Usar helper para Base64 a ArrayBuffer
                        audioQueueRef.current.push(audioBytes);
                        playQueuedAudio(); // Intentar reproducir
                    } else if (message.type === 'error') {
                        console.error('Error del backend:', message.message);
                        setError(`Error del servidor: ${message.message}`);
                    }
                } catch (e) {
                    console.error('Error procesando mensaje:', e, event.data);
                }
            };

        } else {
            // Si ya está conectado, simplemente iniciar los streams
            startMediaStreams();
        }

    }, [isStreaming, stopStreamingAndDisconnect, playQueuedAudio]); // Dependencias: isStreaming, stopStreamingAndDisconnect, playQueuedAudio


    // --- Función Interna para Iniciar Media Streams (Audio + Pantalla opcional) ---
    const startMediaStreams = useCallback(async () => {
        // Esta función asume que el WebSocket ya está conectado o en proceso
        if (isStreaming) return; // Ya está activo

        console.log("2.1 Iniciando captura de audio (PCM)...");
        setError(null); // Limpiar errores de media antes de intentar

        try {
            // 1. Crear/Reanudar AudioContext (para captura y reproducción)
            if (!audioContextRef.current || audioContextRef.current.state === 'closed') {
                console.log("2.1.1 Creando nuevo AudioContext...");
                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)({
                    sampleRate: AUDIO_REQUESTED_SAMPLE_RATE // Intentar que el contexto use 16kHz
                });
            }
            if (audioContextRef.current.state === 'suspended') {
                console.log("2.1.2 Reanudando AudioContext suspendido...");
                await audioContextRef.current.resume();
            }
            const audioContext = audioContextRef.current;
            // Verificar si la tasa de muestreo es la esperada
            if (audioContext.sampleRate !== AUDIO_REQUESTED_SAMPLE_RATE) {
                console.warn(`2.1.3 AudioContext NO opera a ${AUDIO_REQUESTED_SAMPLE_RATE}Hz, sino a ${audioContext.sampleRate}Hz. El backend podría necesitar resampling si no lo maneja.`);
                // Podrías mostrar un error o continuar asumiendo que el backend lo maneja
            } else {
                console.log(`2.1.4 AudioContext operando a ${audioContext.sampleRate}Hz.`);
            }


            // 2. Acceso al Micrófono
            console.log(`2.2 Solicitando audio a ${AUDIO_REQUESTED_SAMPLE_RATE}Hz...`);
            const audioStream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    sampleRate: AUDIO_REQUESTED_SAMPLE_RATE, // Solicitar 16kHz
                    channelCount: 1, // Mono
                    echoCancellation: true,
                    noiseSuppression: true,
                },
                video: false // Solo audio aquí
            });
            localAudioStreamRef.current = audioStream; // Guardar para detener tracks luego

            // 3. Configurar Web Audio API para procesar PCM
            audioStreamSourceRef.current = audioContext.createMediaStreamSource(audioStream);
            scriptProcessorNodeRef.current = audioContext.createScriptProcessor(
                AUDIO_BUFFER_SIZE, // Tamaño del buffer (e.g., 4096)
                1, // Canales de entrada (mono)
                1  // Canales de salida (mono)
            );

            scriptProcessorNodeRef.current.onaudioprocess = (event) => {
                // Solo procesar si NO está muteado Y el streaming principal está activo Y WS está abierto
                if (mutedRef.current || !ws.current || ws.current.readyState !== WebSocket.OPEN) {
                    console.log("2.3 Muted or disconected (no process audio)")
                    // console.log("---", muted, !ws.current, ws.current.readyState !== WebSocket.OPEN)

                    return;
                }

                const inputData = event.inputBuffer.getChannelData(0); // Float32Array (-1.0 a 1.0)

                const originalSampleRate = audioContextRef.current.sampleRate;

                const audioBuffer = audioContextRef.current.createBuffer(1, inputData.length, originalSampleRate);
                audioBuffer.copyToChannel(inputData, 0, 0);

                // Resamplear el AudioBuffer a la tasa deseada (por ejemplo, 16000 Hz)
                // resampleAudioBuffer(audioBuffer, AUDIO_REQUESTED_SAMPLE_RATE)
                //     .then((resampledBuffer) => {
                //         // Ahora resampledBuffer contiene el audio con la tasa de 16000 Hz
                //         // Puedes convertirlo a ArrayBuffer, Base64, o enviarlo al backend según lo necesites.
                //         console.log('Resampleo completado. Nueva tasa:', resampledBuffer.sampleRate, resampledBuffer);
                //         const base64AudioPCM = arrayBufferToBase64(resampledBuffer);
                //
                //         // Enviar PCM 16-bit Base64 al backend
                //         sendData({
                //             type: 'audio',
                //             mime_type: `audio/pcm;rate=${AUDIO_REQUESTED_SAMPLE_RATE}`, // ¡¡IMPORTANTE!! Enviar el mimeType correcto
                //             data: base64AudioPCM
                //         });
                //     })
                //     .catch((err) => {
                //         console.error('Error al resamplear:', err);
                //     });


                // Convertir Float32 a Int16
                const int16Buffer = new Int16Array(inputData.length);
                for (let i = 0; i < inputData.length; i++) {
                    const sample = Math.max(-1, Math.min(1, inputData[i])); // Clamp
                    int16Buffer[i] = sample < 0 ? sample * 32768 : sample * 32767; // Convertir a Int16
                }

                // Convertir Int16Array (su ArrayBuffer) a Base64
                const base64AudioPCM = arrayBufferToBase64(int16Buffer.buffer);

                // Enviar PCM 16-bit Base64 al backend
                sendData({
                    type: 'audio',
                    mime_type: `audio/pcm;rate=${AUDIO_REQUESTED_SAMPLE_RATE}`, // ¡¡IMPORTANTE!! Enviar el mimeType correcto
                    data: base64AudioPCM
                });
            };

            // Conectar los nodos: source -> processor -> destination
            // Conectar a destination es necesario para que onaudioprocess se dispare,
            // incluso si no queremos oírlo localmente (se puede mutear el <audio> o el stream).
            audioStreamSourceRef.current.connect(scriptProcessorNodeRef.current);
            scriptProcessorNodeRef.current.connect(audioContext.destination);

            console.log("2.4 Web Audio API configurada para procesar PCM.");

            // Set state ONLY AFTER successful media acquisition
            setIsStreaming(true);
            console.log("2.5 Audio streaming iniciado.");

        } catch (err) {
            console.error('Error al iniciar audio stream:', err);
            let userMessage = `Error al acceder al micrófono: ${err.message || err.name || 'desconocido'}`;
            if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') userMessage = 'Permiso denegado para micrófono.';
            else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') userMessage = 'Micrófono no encontrado.';
            else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') userMessage = 'Micrófono ya en uso o no se puede leer.';
            else if (err.name === 'OverconstrainedError' || err.name === 'ConstraintNotSatisfiedError') userMessage = `Parámetros solicitados (ej. ${AUDIO_REQUESTED_SAMPLE_RATE}Hz) no soportados.`;
            setError(userMessage);
            // Asegurar limpieza si falla el inicio de media
            stopStreamingAndDisconnect(); // Esto también pondrá isStreaming a false y cerrará WS
        }
    }, [isStreaming, sendData, stopStreamingAndDisconnect]); // Dependencias: isStreaming, muted, sendData, stopStreamingAndDisconnect


    // --- Iniciar Compartir Pantalla ---
    // const startScreenSharing = useCallback(async () => {
    //     if (!isStreaming || isScreenSharing) return; // Solo si el streaming principal está activo y no compartiendo ya
    //
    //     console.log("Iniciando compartir pantalla...");
    //     setError(null); // Limpiar errores de pantalla
    //
    //     try {
    //         const stream = await navigator.mediaDevices.getDisplayMedia({
    //             video: { cursor: "always" }, // Opciones de video para compartir pantalla
    //             audio: false // Generalmente el audio de pantalla se maneja por separado o no se incluye
    //         });
    //         videoStreamRef.current = stream;
    //
    //         // Usar un elemento de video oculto para procesar los frames
    //         if (!videoElementForCaptureRef.current) {
    //             videoElementForCaptureRef.current = document.createElement('video');
    //             videoElementForCaptureRef.current.style.display = 'none'; // Oculto
    //             document.body.appendChild(videoElementForCaptureRef.current);
    //         }
    //         const videoEl = videoElementForCaptureRef.current;
    //         videoEl.srcObject = stream;
    //         videoEl.muted = true; // Importante para un video que no se muestra
    //         await videoEl.play(); // Necesario para que el video empiece a recibir datos
    //
    //         // Escuchar cuando el usuario detiene el stream desde los controles del navegador
    //         stream.getVideoTracks()[0].onended = () => {
    //             console.log("Screen sharing stopped by user (browser UI).");
    //             stopScreenSharing(); // Llama a nuestra función de limpieza de pantalla
    //         };
    //
    //         // Intervalo para capturar y enviar frames
    //         screenCaptureIntervalRef.current = setInterval(() => {
    //             // Solo capturar si el streaming principal está activo Y se está compartiendo pantalla Y el video está listo
    //             if (!isStreaming || !isScreenSharing || !videoEl || videoEl.paused || videoEl.ended || videoEl.videoWidth === 0) {
    //                 // console.log("Omitiendo captura de frame (streaming/sharing inactivo o video no listo)");
    //                 return;
    //             }
    //             try {
    //                 const canvas = document.createElement('canvas');
    //                 canvas.width = videoEl.videoWidth;
    //                 canvas.height = videoEl.videoHeight;
    //                 const ctx = canvas.getContext('2d');
    //                 ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);
    //                 const frameDataUrl = canvas.toDataURL('image/jpeg', 0.7); // JPEG es eficiente
    //                 const base64Frame = frameDataUrl.split(',')[1];
    //
    //                 if (base64Frame) {
    //                     // console.log(`Enviando frame de video (${canvas.width}x${canvas.height})...`);
    //                     sendData({
    //                         type: 'video',
    //                         mime_type: 'image/jpeg', // Indicar que es un frame JPEG
    //                         data: base64Frame
    //                     });
    //                 }
    //             } catch (frameError) {
    //                 console.error("Error capturando o enviando frame de video:", frameError);
    //                 // Opcional: Detener el intervalo si hay errores repetidos para evitar spam
    //                 // if (screenCaptureIntervalRef.current) {
    //                 //     clearInterval(screenCaptureIntervalRef.current);
    //                 //     screenCaptureIntervalRef.current = null;
    //                 // }
    //             }
    //         }, VIDEO_FRAME_INTERVAL_MS);
    //
    //         setIsScreenSharing(true); // Set state on success
    //         console.log("Screen sharing started.");
    //
    //     } catch (err) {
    //         console.error('Error starting screen sharing:', err);
    //         let userMessage = `Error al compartir pantalla: ${err.message || err.name || 'desconocido'}`;
    //         if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') userMessage = 'Permiso denegado para compartir pantalla.';
    //         setScreenError(userMessage);
    //         stopScreenSharing(); // Limpiar en caso de error
    //     }
    // }, [isStreaming, isScreenSharing, sendData]); // Dependencias: isStreaming, isScreenSharing, sendData


    // --- Detener Compartir Pantalla ---
    // const stopScreenSharing = useCallback(() => {
    //     if (!isScreenSharing) return; // Solo detener si está activo
    //
    //     console.log("Stopping screen sharing...");
    //
    //     if (screenCaptureIntervalRef.current) {
    //         clearInterval(screenCaptureIntervalRef.current);
    //         screenCaptureIntervalRef.current = null;
    //     }
    //     if (videoStreamRef.current) {
    //         videoStreamRef.current.getTracks().forEach(track => track.stop());
    //         videoStreamRef.current = null;
    //     }
    //     if (videoElementForCaptureRef.current) {
    //         videoElementForCaptureRef.current.srcObject = null;
    //         videoElementForCaptureRef.current.remove(); // Eliminar el elemento del DOM
    //         videoElementForCaptureRef.current = null;
    //     }
    //
    //     setIsScreenSharing(false); // Set state on cleanup
    //     setScreenError(null); // Limpiar error de pantalla al detener
    //     console.log("Screen sharing stopped.");
    // }, [isScreenSharing]); // Dependencia: isScreenSharing


    // --- Efecto de Limpieza al Desmontar el Componente ---
    useEffect(() => {
        // Intentar conectar WebSocket al montar (opcional, el botón también lo hace)
        // connectWebSocket(); // Si quieres que intente conectar al cargar la página

        // Limpieza al desmontar: detener streams y cerrar WebSocket
        return () => {
            console.log("Desmontando ChatTest, asegurando cierre de WebSocket y streams...");
            stopStreamingAndDisconnect(); // Llama a la función que detiene todo
            // Asegurarse de cerrar AudioContext si se creó

            if (volumeIntervalRef.current) {
                clearInterval(volumeIntervalRef.current);
            }
            if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
                audioContextRef.current.close().then(() => console.log("AudioContext cerrado al desmontar."));
                audioContextRef.current = null;
            }
        };
    }, []); // Dependencia: stopStreamingAndDisconnect

    const handleContinueInterview = () => {
        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
            ws.current.send(JSON.stringify({
                type: 'text_to_audio',
                data: 'continue'
            }));
        }
    };

    const handleEndInterview = () => {
        if (ws.current && ws.current.readyState === WebSocket.OPEN) {
            ws.current.send(JSON.stringify({
                type: 'text',
                data: 'finish the interview'
            }));
        }
        stopStreamingAndDisconnect()
        closeLiveInterview()
    };


    // --- Renderizado ---
    return (
        hideLiveInteraction ?
            <div className="error-message mui-paper mui-alert mui-alert-error">You cannot view this content</div>
            : <div className="App chat-test-mui-inspired"> {/* La clase App debería adaptarse al ancho del padre */}
            {/* Timer */}
            <ConversationTimer isStreaming={isStreaming}/>


            {/* Mensaje de Error General */}
            {error && <div className="error-message mui-paper mui-alert mui-alert-error">{error}</div>}

            <div className="controls mui-stack">
                {/* Estado de Conexión (Texto minimalista) */}
                {/*<div className="status-text">*/}
                {/*    /!*Connection: {isConnected ? <span style={{color: 'green'}}>Connected</span> : <span style={{color: 'red'}}>Disconnected</span>}*!/*/}

                {/*    <span className={`connection-dot ${isConnected ? 'connected' : 'disconnected'}`}/>*/}
                {/*</div>*/}

                <AudioPulse active={isBotSpeaking} volume={botOutputVolume}/>

                {/* Botón Mute (Visible y habilitado solo si el streaming principal está activo) */}
                {isStreaming && (
                    <button
                        className={`control-button mui-icon-button`}
                        onClick={() => setMuted(!muted)}
                        title={muted ? "Activar micrófono" : "Silenciar micrófono"}
                    >
                        <FontAwesomeIcon icon={muted ? faMicrophoneSlash : faMicrophone}/>
                    </button>
                )}

                {/* Botón Principal: Iniciar/Detener Streaming */}
                {!isStreaming ? (
                    <button
                        className="control-button mui-fab mui-fab-extended mui-fab-success"
                        onClick={startStreamingAndConnect}
                        disabled={isStreaming} // Deshabilitado si ya está streameando
                        title="Iniciar Conversación de Voz"
                    >
                        <FontAwesomeIcon icon={faPhone} />
                    </button>
                ) : (
                    <button
                        className="control-button mui-fab mui-fab-extended mui-fab-error"
                        onClick={() => {
                            stopStreamingAndDisconnect()
                            closeLiveInterview()
                        }}
                        disabled={!isStreaming} // Deshabilitado si no está streameando
                        title="Detener Conversación de Voz"
                    >
                        {/*<FontAwesomeIcon icon={faStop} /> /!* Icono de Stop *!/*/}
                        <FontAwesomeIcon icon={faPhoneSlash} />
                    </button>
                )}

                {/* Botón de Compartir Pantalla (Visible y habilitado solo si el streaming principal está activo) */}
                {/*{isStreaming && (*/}
                {/*    <button*/}
                {/*        className={`control-button round-button ${isScreenSharing ? 'streaming' : ''}`}*/}
                {/*        onClick={isScreenSharing ? stopScreenSharing : startScreenSharing} // Llama a iniciar o detener pantalla*/}
                {/*        disabled={!isStreaming} // Deshabilitado si el streaming principal no está activo*/}
                {/*        title={isScreenSharing ? "Dejar de Compartir Pantalla" : "Compartir Pantalla"}*/}
                {/*    >*/}
                {/*        <FontAwesomeIcon icon={isScreenSharing ? faVideoSlash : faVideo} />*/}
                {/*    </button>*/}
                {/*)}*/}
            </div>

            {/* Indicador de que Gemini está hablando (opcional, si el backend lo indica) */}
            {/* {isPlayingAudioRef.current && <div className="message gemini"><em>(Gemini is speaking...)</em></div>}*/}

            {/* render feedback list */}

            {/*<FeedbackList items={feedbackEntries}*/}
            {/*              onContinue={handleContinueInterview}*/}
            {/*              onEnd={handleEndInterview}*/}
            {/*/>*/}
        </div>
    );
}

const mapStateToProps = (state) => {
    console.log("state", state);
    return {
        user: state.users.user
    };
};

// Map dispatch to props;
const mapDispatchToProps = (dispatch) => {
    return {

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ChatTest);
